var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSearchHotels = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 160,
    height: 120,
    fill: "none",
    viewBox: "0 0 160 120",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#454560",
    d: "M21.376 111.064c-.187 0-3.166 1.212-4.842-4.754 0 0-3.072-13.795.745-13.33 0 0 3.817 4.289 2.141 13.237l3.445.093-.186 2.797-1.397 2.237z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#69697F",
    d: "M23.796 89.532a42.2 42.2 0 0 0-7.169 3.449s4.004 4.288 2.793 13.236l4.004.186 1.862-8.762z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#8F90A0",
    d: "M20.258 88.973s6.145 21.345-.28 22.091c0 0 1.49 3.356 16.946-2.61l-5.12-25.54z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#69697F",
    d: "M30.872 95.032s-.559 12.863-6.331 16.778c0 0 2.7.28 9.683-2.144l-.466-13.982z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#EF795C",
    d: "M78.169 88.227s23.462-5.313 26.813 3.076l2.794 44.836-26.07 1.025-.558-26.007-18.528 1.771s-4.934 18.364-2.607 35.888l-.558 26.845-24.393 2.797-1.304-18.829c-.745-.28-1.303-.933-1.396-1.678l-.466-17.711s.186-2.237 1.862-2.144l-1.769-32.625z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#8F90A0",
    d: "M66.065 93.447 43.07 108.175l-2.142 6.711s-3.63 6.525-1.955 10.533l2.514 12.957-7.728-.28-1.769-32.345 8.287-4.567z",
    opacity: 0.7
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M68.207 91.955s-12.29.56-20.856 3.729c0 0-10.148 4.195-15.92 4.567v4.754c0 .56.372.932.93.932h.28c3.259-.839 12.383-3.542 15.735-6.431z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#DDDDE5",
    d: "M68.207 91.955s-12.29.56-20.856 3.729c0 0-10.148 4.195-15.92 4.567l-.093 2.61s12.941-1.305 17.038-4.94z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#9FBEE5",
    d: "M27.8 31.74S11.972 44.136 17.372 81.142a5.72 5.72 0 0 0 4.003 4.753 33.2 33.2 0 0 0 9.59.84l2.98-28.804 5.586-13.516-.28-10.16z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#9FBEE5",
    d: "M20.258 43.018S9.644 53.272 16.534 67.44l2.514-8.39z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#F9B450",
    d: "m94.09 42.459-.187.186zl.373-1.585.651.187c-.372.466-.744.932-1.024 1.398"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#8F90A0",
    d: "M26.869 32.858s-5.494 8.296-3.259 11.372c0 0-7.82 9.694-.559 24.422 3.631 1.118 7.542 1.491 11.359 1.212L24.448 85.99S17.65 87.48 17 78.626L16.44 66.6c-3.631-7.643-2.234-16.685 3.445-22.93l1.303-1.771s2.793-6.991 5.68-9.042",
    opacity: 0.6
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    stroke: "#D1445C",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.83,
    d: "M31.524 47.12s-7.355-1.305-11.08-4.475"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    stroke: "#8F90A0",
    strokeMiterlimit: 10,
    strokeWidth: 1.24,
    d: "M30.779 47.679s-7.355-1.305-11.08-4.474M28.265 69.77s-7.448.466-11.917-1.677",
    opacity: 0.6
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#F9B450",
    d: "m26.217 82.075 2.607-7.178s-5.959-6.99-.931-11.745c0 0-7.635-10.72 4.282-16.965 0 0-1.117-11.838 12.756-14.354l-6.61-6.246S27.612 5.08 55.264.14c2.328-.373 4.748 0 6.797 1.118l5.12 2.89 1.118 2.33-7.355 6.153-7.449 2.703-2.42 6.525 3.258 13.05 8.1 2.423 7.448-.932s4.376 2.89 5.68 5.966c0 0 1.117-2.237 2.793-1.585l5.4 6.432-1.862 2.517 2.234 4.38 7.635-7.084a4.5 4.5 0 0 0 0 1.585c.093 1.119.558 2.237.651 3.449.094 1.77-.837 3.076-1.955 4.38-1.582 1.772-3.165 3.263-4.096 5.407-1.21 2.89-.373 8.11-3.445 8.762-14.71 2.89-4.283 2.144-2.7 3.45-3.352-.653 1.955 3.448 1.955 3.448s2.141 6.805-5.12 10.906L65.32 92.794l-9.403 1.865-23.742 5.872c0-.093-11.265.559-5.958-18.456"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#F3921A",
    d: "m52.565 16.825-2.42 6.245 2.234 8.762c-2.98-.373-6.052-.466-9.031-.373l-5.028-5.686S27.893 4.334 54.148 3.124c1.117 0 2.327.186 3.352.745l5.679 4.008 4.283.653-7.355 5.872z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#729CD3",
    d: "M41.393 32.951s-2.42-2.517-7.728-3.076c0 0-5.4-.093-5.865 1.864 0 0 8.1 1.771 9.59 3.915l3.91-1.678z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#F9B450",
    d: "M72.676 68.093c4.19 2.05 7.634 5.5 9.59 9.787 0 0-.094 8.296-4.097 10.44l-9.031 3.542-4.842.932-22.996 5.22-8.752 2.61s-9.031 1.865-7.448-13.888l3.817-11.746s-6.983-5.5-1.117-11.278c0 0 4.469 5.779 8.286 5.5 0 0 3.445 11.092 16.665 4.94 0 0 15.27 7.83 19.18-3.822-.093 0-.559.932.745-2.237"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#F3921A",
    d: "M69.882 36.4S58.244 56.907 48.47 44.137l-4.656-8.39 5.96-3.821L61.41 36.4z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#F3921A",
    d: "M47.072 45.349s-2.328-8.017-10.707-9.508l5.959-2.424 3.724 4.66 1.303 4.941z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#8F90A0",
    d: "M69.882 36.4S58.244 56.907 48.47 44.137l-4.656-8.39 5.96-3.821L61.41 36.4z",
    opacity: 0.3
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#8F90A0",
    d: "M47.072 45.349s-2.328-8.017-10.707-9.508l5.959-2.424 3.724 4.66 1.303 4.941z",
    opacity: 0.3
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#454560",
    d: "M40.927 33.23c3.724 3.636 5.959 8.576 5.959 13.796l5.027 1.119c-.372-6.152-2.886-11.931-6.982-16.406-.373-.373-.838-.373-1.304-.186l-3.352 1.212c-.279.186-.372.466-.372.745z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#F9CAB5",
    d: "M61.13 36.866c-5.09 0-9.217-5.008-9.217-11.186 0-6.177 4.127-11.185 9.218-11.185 5.09 0 9.217 5.008 9.217 11.185S66.22 36.866 61.13 36.866"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#F1F2F8",
    d: "M50.796 12.258s2.7-9.788 10.8-2.89c0 0 4.097-7.27 9.683-2.517.838 1.492.838 3.356-.186 4.754 0 0 10.614 0 2.886 8.949l-3.073 6.525S76.68 38.73 68.02 37.424c0 0-4.282 6.339-8.1 1.119 0 0-6.61 4.008-6.424-2.33 0 0-12.755.186-5.027-12.398 0 .093-9.683-10.626 2.327-11.558m4.376 22.184s5.959-3.821 6.145 1.865c0 0 2.141-3.822 5.027-1.119 0 0-3.258-4.195 3.073-8.39l-1.77-3.82s-2.513-1.679.746-3.077c0 0-5.959.932-3.259-4.754 0 0-1.955 4.008-6.424 1.119 0 0 .931 6.898-5.214 4.567 0 0 5.586 4.94-.372 7.457.186 0 4.748 1.119 2.048 6.152"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#CDCDD7",
    d: "M66.065 34.442c-.558-1.491-1.024-4.474 3.538-7.55l-1.769-3.822s-2.793-1.864.559-3.262c0 0-5.587.839-3.445-4.474 1.769.466 3.63-.187 4.655-1.771-2.7 5.779 3.259 4.753 3.259 4.753-3.259 1.305-.745 3.076-.745 3.076l.745 1.678-1.956 4.102.187.466c-1.49 1.678-1.676 4.194-.373 5.965-2.141-1.957-4.003-.093-4.655.84M55.079 10.673c-1.397.093-2.793.373-4.097 1.025.56-1.491 2.328-5.313 6.145-4.754-.93 1.119-1.676 2.33-2.048 3.729M50.238 12.444c-3.445 3.263 2.606 9.974 2.606 9.974-7.727 12.584 5.028 12.397 5.028 12.397-.186 6.339 6.424 2.33 6.424 2.33.559.933 1.49 1.585 2.607 1.958-1.583 1.492-4.283 3.076-6.796-.373 0 0-6.61 4.009-6.425-2.33 0 0-12.755.186-5.027-12.397-.093 0-9.404-10.254 1.583-11.559"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#EF795C",
    d: "M99.21 42.086s5.866-5.686 1.21-11.465l-7.169.186-4.748 2.237s-.745 5.313 3.259 8.296l6.051 1.958z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#8F90A0",
    d: "M99.21 42.086s5.866-5.686 1.21-11.465l-7.169.186-4.748 2.237s-.745 5.313 3.259 8.296l6.051 1.958z",
    opacity: 0.5
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#F3921A",
    d: "M80.776 74.99c-.931-.28-2.328-2.423-2.794-3.169a11 11 0 0 1-1.396-2.516c4.562-1.772 7.355-6.339 7.076-11.186-.187-2.703-.652-5.313-1.49-7.83L80.31 48.61s4.003-4.847 7.82-4.847l.652.093 1.49-3.822 8.286 2.424 1.21.28-1.21 2.796.838 1.119s6.983 15.38-7.355 18.456l-.931.28s-1.303 9.228-10.055 9.694c-.093 0-.186-.094-.28-.094"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#454560",
    d: "m103.027 18.503-11.73.466-.187 14.541 12.197.187z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#1B1934",
    d: "M103.027 33.697c-1.439 0-2.607-3.422-2.607-7.644s1.168-7.643 2.607-7.643 2.607 3.422 2.607 7.643c0 4.222-1.167 7.644-2.607 7.644"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#69697F",
    d: "m60.665 22.511 3.538 1.119-4.283 1.491 1.304-1.212-2.7-.372 3.258-.187z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#454560",
    d: "m75.934 20.927-11.358.28-.373 7.643 11.731.28z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#454560",
    d: "M64.855 28.943c-1.08 0-1.955-1.753-1.955-3.915s.875-3.915 1.955-3.915 1.955 1.753 1.955 3.915-.875 3.915-1.955 3.915"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#69697F",
    d: "M74.258 33.044c-.093-.093-.279-.186-.372-.186l.465-14.355 17.41-.746v16.5l-16.944-.653q-.14-.28-.559-.56"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#69697F",
    d: "M74.817 33.697c-1.388 0-2.514-3.422-2.514-7.644s1.126-7.643 2.514-7.643 2.514 3.422 2.514 7.643c0 4.222-1.126 7.644-2.514 7.644"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "#B2B2BF",
    d: "M91.855 34.163c-1.646 0-2.98-3.673-2.98-8.203s1.334-8.203 2.98-8.203 2.98 3.673 2.98 8.203-1.335 8.203-2.98 8.203"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "#1B1934",
    d: "M91.855 32.765c-1.183 0-2.142-3.047-2.142-6.805s.96-6.805 2.142-6.805 2.141 3.047 2.141 6.805-.959 6.805-2.141 6.805"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "#8F90A0",
    d: "M103.12 33.604c-1.594 0-2.886-3.423-2.886-7.644 0-4.222 1.292-7.644 2.886-7.644s2.887 3.422 2.887 7.644-1.293 7.643-2.887 7.643"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "#1B1934",
    d: "M103.12 32.205c-1.131 0-2.048-2.796-2.048-6.245s.917-6.245 2.048-6.245 2.049 2.796 2.049 6.245-.917 6.245-2.049 6.245"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    stroke: "#F5A996",
    strokeMiterlimit: 10,
    strokeWidth: 0.41,
    d: "m50.33 106.683-3.072 28.803-.838 28.43M83.29 87.668s15.548 2.143 15.454 7.83l.56 24.608"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "#8F90A0",
    d: "M105.448 30.527s-6.424.653-9.87-.093l-1.116-.093-.466 1.212q-2.094.42-4.19 0s-15.361 1.398-17.41-4.94c0 0-7.169.28-9.03-3.543 0 0-2.515 3.636 0 5.873l9.216.186s.28 5.034 3.166 4.66l16.014.56s1.117-.186 1.396-.745l10.149.186c1.117-.746 1.955-1.864 2.141-3.263",
    opacity: 0.58
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "#EF795C",
    d: "m77.145 40.595.465-3.729s-4.283-2.424-2.793-12.77c0 0 3.072-3.45 3.165 1.398 0 0-.093 4.94.931 7.737h.187s-.838-6.712.372-9.881c0 0 4.19-2.703 2.793 3.076q0 3.495.28 6.991l.186-.093s-.652-7.55 1.303-9.88c0 0 2.98-.933 2.607 1.584l-.931 5.406.093 3.729c.093.373 0 .28 0-.093-.186-2.144.745-5.966 2.142-6.339 0 0 2.7-.28.837 3.729l-.651 3.728s4.096 9.788-4.656 11.745z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "#EF795C",
    d: "m99.862 42.739-9.59-2.704c-.745 1.119-1.303 2.424-1.49 3.822l9.683 1.864c.931-.745 1.397-1.864 1.397-2.982"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "#8F90A0",
    d: "m99.862 42.739-9.218-3.636s-1.769 2.89-1.862 4.661l9.683 1.864c.838-.652 1.397-1.77 1.397-2.89",
    opacity: 0.5
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "#EF795C",
    d: "m84.127 47.4-2.234 2.796-7.82-6.246s.65-3.262 2.978-3.542l6.518 6.712"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "#D1445C",
    d: "m84.127 47.4-2.234 2.796-7.82-6.246s.65-3.262 2.978-3.542l6.518 6.712",
    opacity: 0.5
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "#8F90A0",
    d: "M77.424 23.257s-2.793.373-2.235 5.127c0 0-.558 5.686 4.004 8.482l-.373 4.288 2.049 3.17-2.887-2.89s-1.21 3.355-.186 5.313l-3.817-2.703s.559-3.077 3.072-3.636l.466-3.635s-4.376-2.424-2.793-12.584l1.024-1.025s1.303-.746 1.676.093",
    opacity: 0.5
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    stroke: "#FFEBD0",
    strokeMiterlimit: 10,
    strokeWidth: 0.41,
    d: "M61.224 49.636c-.186-3.076-1.304-7.736-1.21-10.812"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    stroke: "#FFEBD0",
    strokeMiterlimit: 10,
    strokeWidth: 0.62,
    d: "M71.558 90.464c2.514-3.542 1.024-6.618-.093-9.974a15.3 15.3 0 0 0-2.234-4.847"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    stroke: "#D1445C",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.83,
    d: "M29.941 68.372s-8.565 2.237-13.78-1.025"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "#F3921A",
    d: "M27.986 75.177s-5.959-6.245-.093-12.025c0 0 .651 4.288 7.262 6.246 0 0 3.445 11.092 16.665 4.94 0 0 10.987 5.686 16.666.186a9.9 9.9 0 0 0 2.42-4.008s-.465.932.838-2.33c0 0 2.7 2.144 4.842 1.118-2.235 4.754-9.404 10.534-19.086 13.423 0 0-13.314 5.78-15.921 14.914l-1.303.28-8.752 2.61s-8.938 1.864-7.448-13.889z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "#8F90A0",
    d: "M27.986 75.177s-5.959-6.245-.093-12.025c0 0 .651 4.288 7.262 6.246 0 0 3.445 11.092 16.665 4.94 0 0 10.987 5.686 16.666.186a9.9 9.9 0 0 0 2.42-4.008s-.465.932.838-2.33c0 0 2.7 2.144 4.842 1.118-2.235 4.754-9.404 10.534-19.086 13.423 0 0-13.314 5.78-15.921 14.914l-1.303.28-8.752 2.61s-8.938 1.864-7.448-13.889z",
    opacity: 0.3
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "#8F90A0",
    d: "m65.227 103.421 16.107 1.491 4.47-5.686-1.77 9.321 1.955 7.83 3.445 7.085-2.141 7.457.093.652 15.362.466-14.99 2.051-5.958-.093-.559-22.838-18.528 1.771z",
    opacity: 0.7
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "#454560",
    d: "M36.272 71.821c1.024 1.585 2.607 2.89 4.376 3.636-1.769 1.584-8.938 7.364-17.41 7.457l.372-6.898c0-.093 8.566-.093 12.662-4.195"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "#8F90A0",
    d: "M36.83 72.66c1.304 1.958 2.98 2.517 4.377 3.076-1.77 1.585-8.566 11.372-18.062 8.855l.558-7.736c-.093 0 9.031-.093 13.128-4.195",
    opacity: 0.4
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "#F3921A",
    d: "M41.393 63.805c-2.16 0-3.91-1.795-3.91-4.008s1.75-4.009 3.91-4.009 3.91 1.795 3.91 4.009c0 2.213-1.75 4.008-3.91 4.008"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#729CD3",
    strokeMiterlimit: 10,
    strokeWidth: 0.83,
    d: "M42.51 62.873c-1.954 0-3.538-1.544-3.538-3.45 0-1.904 1.584-3.448 3.538-3.448s3.538 1.544 3.538 3.449-1.584 3.449-3.538 3.449Z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "#9FBEE5",
    d: "m44.93 61.568-2.327-3.915-2.328 3.915s1.863 2.423 4.656 0"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fill: "#F3A188",
    d: "M57.965 27.824c.186.746.559 1.305 1.024 1.865 1.49 1.398 3.724 1.677 5.4.559-.651 1.398-2.327 2.237-3.817 1.864-3.072-.839-2.7-4.474-2.607-4.288"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fill: "#8F90A0",
    d: "M25.286 84.405s-3.538 16.499 35.1 9.042l-17.038 3.822s-13.22 5.219-15.92 2.423c-.094.093-6.704-5.5-2.142-15.287M44.745 4.987s-8.938 6.711 1.396 24.702l-.559 3.262-7.262-7.27S31.058 9.087 44.838 3.308z",
    opacity: 0.4
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fill: "#F3921A",
    d: "M83.941 58.958c0-2.983-.652-5.873-1.769-8.67l-.186-.186 2.141-2.796c.093 0 0 0-.465-.28l-.373-.28c2.049-.279 4.097-1.304 4.842-3.075h.093c.651.28.651.093.745-.56 0-.28.279-.745.279-1.025.186-.373.372-.839.558-1.212.187-.186.56-1.025.652-1.118v-.187c-1.21-1.491-1.862-3.449-1.862-5.406h2.514c.745.186 1.583-.186 2.048-.839l9.124.186v.56s-7.169 0-8.565 2.05c-.28.933-.745 1.865-1.49 2.517.186 1.212 1.117 2.144 2.235 2.424 0 0 .093.093.186.28-.931-.094-1.769 0-2.607.186-.372.093-.745.28-.931.652-.466.28-.652.84-.372 1.305.093.093.093.187.186.28.372.28.745.466 1.21.466.093.093.186.093.28.093l.837.187h-.093s-6.89.559-6.145 8.855c0 0 4.004 15.753-3.351 21.066l-2.887.28c-2.606-1.864-4.003-5.593-4.003-5.593 4.097-1.678 6.89-5.593 7.169-10.16",
    opacity: 0.5
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fill: "#8F90A0",
    d: "M83.941 58.958c0-2.983-.652-5.873-1.769-8.67l-.186-.186 2.141-2.796c.093 0 0 0-.465-.28l-.373-.28c2.049-.279 4.097-1.304 4.842-3.075h.093c.651.28.651.093.745-.56 0-.28.279-.745.279-1.025.186-.373.372-.839.558-1.212.187-.186.56-1.025.652-1.118v-.187c-1.21-1.491-1.862-3.449-1.862-5.406h2.514c.745.186 1.583-.186 2.048-.839l9.124.186v.56s-7.169 0-8.565 2.05c-.28.933-.745 1.865-1.49 2.517.186 1.212 1.117 2.144 2.235 2.424 0 0 .093.093.186.28-.931-.094-1.769 0-2.607.186-.372.093-.745.28-.931.652-.466.28-.652.84-.372 1.305.093.093.093.187.186.28.372.28.745.466 1.21.466.093.093.186.093.28.093l.837.187h-.093s-6.89.559-6.145 8.855c0 0 4.004 15.753-3.351 21.066l-2.887.28c-2.606-1.864-4.003-5.593-4.003-5.593 4.097-1.678 6.89-5.593 7.169-10.16",
    opacity: 0.5
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fill: "#69697F",
    d: "M63.458 19.715c-1.21.093-2.327.559-3.165 1.305l-.559-.187s.186-1.584 3.352-2.423z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fill: "#FCD9A7",
    d: "m59.362 64.085.093.745c-.093-.28-.093-.56-.093-.745M56.941 54.763c-4.655-4.381-8.472-6.245-10.707-7.084L41.3 45.442s10.986-1.305 16.386 7.084l2.7 3.449s.28-11.186 12.569-12.398c.28.187.93.28 1.21.373l.093.093 7.635 5.966s-14.897-7.457-21.32 7.644c-.839 1.957-1.304 4.194-1.211 6.338l-.652-5.779s-4.096 1.491-4.469 3.635c0 .093-.28-4.38 2.7-7.084"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m42.882 92.515 4.19-.653c.466-.093.838-.466.838-1.025v-.093c-.093-.56-.559-.933-1.117-.84l-4.19.653c-.465.093-.838.56-.838 1.025v.094c.093.466.559.839 1.117.839M39.53 92.98a1.025 1.025 0 1 1 .002-2.049 1.025 1.025 0 0 1-.001 2.05"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSearchHotels);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/search-hotels.016dc95b.svg";